/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateLocationToPartnerV1Dto = {
  /**
   * The type of the relation.
   */
  type?: CreateLocationToPartnerV1Dto.type;
  /**
   * The beginning of the validity of the relation.
   */
  validFrom?: string | null;
  /**
   * The ending of the validity of the relation.
   */
  validTo?: string | null;
  /**
   * The unique identifier as hexadecimal value of the partner linked to this relation. As 8-4-4-4-12 format.
   */
  partnerId: string;
};
export namespace CreateLocationToPartnerV1Dto {
  /**
   * The type of the relation.
   */
  export enum type {
    LANDLORD = 'landlord',
    PROPERTY_MANAGER = 'property_manager',
    LANDLORD_MANAGER = 'landlord_manager',
  }
}
